module.exports = __webpack_public_path__ + "static/Uni_Text-c34392ef4843438447c0f6594626cb51.png";